module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJ5ZXMiPz4KPHN2ZyB3aWR0aD0iMTE4MCIgaGVpZ2h0PSI2NCIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0wIDY0IEwxMTgwIDAgTDExODAgNjQgWiIgZmlsbD0iI0Y3RjdGNyIgLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/rhombus/rhombus-flat-top.svg
// module id = 181
// module chunks = 35783957827783